import React from "react";
import coinImage from '../../images/monnaie.JPG';
import CategoryPage from '../CategoryPage';
import { CATEGORIES_SEO } from '../../seo/pagesSeo';

function MonnaiePage() {
    const seo = CATEGORIES_SEO.monnaie;
    const details = [
        "Louis d’or (France, XVIIe-XVIIIe siècles)",
        "Napoléon (Napoléon III) (France, XIXe siècle)",
        "Souverain d’or (Angleterre, depuis le Moyen Âge)",
        "Pièce d’or du Reich (Allemagne, XVIIIe-XXe siècles)",
        "Französischer Dukat (Autriche, Allemagne, XVIIIe-XIXe siècles)",
        "Vreneli (Suisse, XIXe-XXe siècles)",
        "Escudo d’or (Espagne, époque des Habsbourg et Bourbon)",
        "Pièce d’or de la Renaissance italienne (Italie, XV-XVIe siècles)",
        "Pièce d’or de l’Empire italien (Italie, XIXe siècle)",
        "Goldgulden (Allemagne, époque médiévale à moderne)",
        "5 francs argent (France, période Napoléon III et IIIe République)",
        "Pièce de 1 franc argent (France, XIXe-XXe siècles)",
        "Pièce de 5 francs argent “Liberté-Égalité-Fraternité” (France, XIXe siècle)",
        "Pièce de 10 shillings en argent (Angleterre, XIXe-XXe siècles)",
        "Pièce de 2 Reichsmark en argent (Allemagne, époque du Troisième Reich)",
        "Pièce de 1 franc suisse en argent (Suisse, XIXe-XXe siècles)",
        "Pièce de 50 centimes en argent (Espagne, XIXe siècle)",
        "Pièce de 1 peseta en argent (Espagne, XIXe-XXe siècles)",
        "Pièce de 5 lire en argent (Italie, époque de l’unification italienne)",
        "Pièce de 1 dollar en argent (États-Unis, XIXe siècle)",
        "Médailles de l’élection bourgeoise (France, XVIIIe-XIXe siècles)",
        "Pièces commémoratives des élections municipales (Allemagne, France, XIXe-XXe siècles)",
        "Jetons de vote en argent ou en or (Europe, Moyen Âge et période moderne)",
        "Médaille électorale en argent (Angleterre, XVIIIe-XIXe siècles)",
    ];

    return (
        <CategoryPage
            title="Monnaies de Collection"
            image={coinImage}
            description="Je me spécialise dans l'acquisition de pièces de monnaie anciennes, en or ou en argent, qu'elles soient françaises ou étrangères. Passionné par la numismatique, je reconnais les spécificités et raretés de chaque pièce, qu'il s'agisse de monnaies anciennes ou de médailles commémoratives. Grâce à mon expertise et ma connaissance du marché, je propose une évaluation précise et honnête, et je suis toujours à la recherche de pièces authentiques à ajouter à ma collection.

Contacte-moi pour plus de renseignements.

Voici une liste variée de pièces de monnaie en or et en argent, provenant de différentes régions et époques, y compris la France, l'Allemagne, la Suisse, l'Espagne, l'Angleterre, l'Italie, et les pièces liées à l'élection bourgeoise."
            details={details}
            seoTitle={seo.title}
            seoDescription={seo.description}
            seoPath={seo.path}
        />
    );
}

export default MonnaiePage;
